import { render, staticRenderFns } from "./RemoveConnection.vue?vue&type=template&id=477add2c&"
import script from "./RemoveConnection.vue?vue&type=script&lang=ts&"
export * from "./RemoveConnection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports